<template>
<div class="price-details">
      <h2>{{$t('priceDetail')}}</h2>
      <p>
        <span>{{$t('costPrice')}}</span>
        <span>₹​{{preOrderDetailSection.sellingPrice}}</span>
      </p>
      <p v-if="preOrderDetailSection.treatShipmentCostSeparate">
        <span>{{$t('shippingCharges')}}</span>
        <span>₹​{{preOrderDetailSection.shipmentCost}}</span>
      </p>
       <p v-if="preOrderDetailSection.walletDiscountAmount>0">
        <span>{{$t('walletDiscount')}}</span>
        <span>₹​{{preOrderDetailSection.walletDiscountAmount}}</span>
      </p>
      <p v-if="preOrderDetailSection.mcashDiscountAmount>0">
        <span>{{$t('mpointsDiscount')}}</span>
        <span>₹​{{preOrderDetailSection.mcashDiscountAmount}}</span>
      </p>
      <p v-if="preOrderDetailSection.online>0">
        <span>{{$t('onlineDiscount')}}</span>
        <span>₹​{{preOrderDetailSection.online}}</span>
      </p>
      <p v-if="preOrderDetailSection.discountedCutAmount>0">
        <span>{{$t('cutFromFriendPrice')}}</span>
        <span>₹{{preOrderDetailSection.discountedCutAmount}}</span>
      </p>
      <p v-if="preOrderDetailSection.discountedAmount>0">
        <span>{{$t('extraDiscount')}}</span>
        <span>₹{{preOrderDetailSection.discountedAmount}}</span>
      </p>

      <p v-if="preOrderDetailSection.groupDiscount && preOrderDetailSection.groupDiscount>0">
        <span>{{$t('groupDiscount')}}</span>
        <span>₹{{preOrderDetailSection.groupDiscount}}</span>
      </p>
      <p v-if="!preOrderDetailSection.treatShipmentCostSeparate">
        <span>{{$t('delivery')}}</span>
        <span class="green">FREE</span>
      </p>
      <p>
        <span>
          <b>{{$t('totalAmount')}}</b>
        </span>
        <span>
          <b>{{preOrderDetailSection.totalPaidAmount}}</b>
        </span>
      </p>
    </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "PriceDetail",
  props: {
    dataValues: {
      type: Object,
      required: true
    },
  },
  data(){
    return{
      preOrderDetailSection: { },
    }
  },
   watch: {
    dataValues() {
      if(this.dataValues){
        this.preOrderDetailSection = this.dataValues;
      }
    },
  },
  mounted(){
    if(this.dataValues){
        this.preOrderDetailSection = this.dataValues;
    }
  }
}
  </script>